// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"73777993","707":"e98e0d70","779":"8ac82745"}[chunkId] + ".chunk.js";
};